var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClipboardPlus = function SvgClipboardPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.334 3.333c.775 0 1.162 0 1.48.085a2.5 2.5 0 0 1 1.768 1.768c.085.318.085.706.085 1.48v7.667c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.093c-.534.272-1.235.272-2.635.272H7.334c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635V6.667c0-.775 0-1.163.085-1.48a2.5 2.5 0 0 1 1.768-1.769c.318-.085.705-.085 1.48-.085m3.334 10.834v-5m-2.5 2.5h5M8 5h4c.466 0 .7 0 .878-.091a.833.833 0 0 0 .364-.364c.091-.178.091-.412.091-.878V3c0-.467 0-.7-.09-.878a.833.833 0 0 0-.365-.365c-.178-.09-.412-.09-.878-.09H8c-.467 0-.7 0-.879.09a.833.833 0 0 0-.364.365c-.09.178-.09.411-.09.878v.667c0 .466 0 .7.09.878.08.157.208.284.364.364.179.09.412.09.879.09Z"
  })));
};
export default SvgClipboardPlus;